import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/styles/TrustPlatform.scss";
import PublicIcon from "@mui/icons-material/Public";
import BoltIcon from "@mui/icons-material/Bolt";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import ShieldIcon from "@mui/icons-material/Shield";

const stats = [
  {
    icon: <PublicIcon />,
    title: "Hundreds of Leagues",
    description:
      "From top-flight competitions like the Premier League and Champions League to regional and lower-division football worldwide.",
  },
  {
    icon: <BoltIcon />,
    title: "Real-Time Data",
    description:
      "High-speed data pipelines deliver match events the moment they happen, so you're never watching a stale scoreline.",
  },
  {
    icon: <PhoneIphoneIcon />,
    title: "iOS & Android",
    description:
      "Available on both major platforms, with a free tier so you can start tracking matches without a subscription.",
  },
  {
    icon: <ShieldIcon />,
    title: "Privacy-First",
    description:
      "Your data is handled securely and never sold. See our Privacy Policy for the full details.",
  },
];

function TrustPlatform() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <div className="trust-outer">
      <div className="trust-header" data-aos="fade-up">
        <span className="section-eyebrow">Platform</span>
        <h2 className="section-title">Built to Be a Reliable Football Data Source</h2>
        <p className="section-description">
          Coverage, speed, and consistency — the fundamentals a football
          analytics platform needs to get right before anything else.
        </p>
      </div>

      <div className="trust-grid">
        {stats.map((stat, index) => (
          <div
            className="trust-card"
            key={stat.title}
            data-aos="fade-up"
            data-aos-delay={100 + index * 100}
          >
            <div className="trust-icon">{stat.icon}</div>
            <h3>{stat.title}</h3>
            <p>{stat.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TrustPlatform;
